import React from 'react';
import { useLocation } from 'react-router';

import Page from '@common/components/app-layout/page';
import PageContent from '@common/components/app-layout/page-content';
import V2Iframe from '@common/components/iframe-component/v2-iframe';
import UtilityHeader from '@aware/common/utility-header';
import { usePerformanceLevelsModal } from '@aware/common/performance-levels/classic-to-v2-modal-hook';

const V2SettingsIframe = ({ title, iframeSrc, onLoadCallback = () => undefined }) => {
  const { key } = useLocation();
  const { iframeRef, modal } = usePerformanceLevelsModal();

  return (
    <>
      <UtilityHeader title={title} />
      <Page>
        <PageContent disableScroll>
          {modal}
          <V2Iframe
            iframeSrc={iframeSrc}
            name={title}
            title={title}
            onLoadCallback={onLoadCallback}
            iframeRef={iframeRef}
            key={
              /**
               * Passing key to force component to re-render when location changes to prevent user from
               * getting stuck in an iframe
               */
              key
            }
          />
        </PageContent>
      </Page>
    </>
  );
};

export default V2SettingsIframe;
